import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { connect } from 'react-redux';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { departmentActions } from '../../../../actions/departmentActions';
import DepartmentsForm from './DepartmentForm';

const DepartmentModal = props => {
  const { departments, handleSubmit, handleModalClose } = props;

  return (
    <Dialog
      open={departments.showFormModal}
      onClose={handleModalClose}
      aria-labelledby="form-dialog-title"
    >
      <Toolbar className="text-center">
        <Typography variant="title" color="inherit" className="flex">
          {departments.currentItem ? 'Редактирование ведомства' : 'Создание ведомства'}
        </Typography>
        <IconButton color="inherit" onClick={handleModalClose}>
          <CloseIcon className="blue" />
        </IconButton>
      </Toolbar>

      <DialogContent className="dialog text-left">
        <DepartmentsForm currentItem={departments.currentItem} onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = state => {
  const { departments } = state;

  return {
    departments
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dispatch
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { departments } = stateProps;
  const { dispatch } = dispatchProps;

  const handleSubmit = (values, dispatch) => {
    if (departments.currentItem && departments.currentItem.id) {
      return dispatch(departmentActions.update(values));
    }
    return dispatch(departmentActions.create(values));
  };

  const handleModalClose = () => {
    dispatch(departmentActions.closeFormModal());
  };

  return {
    ...ownProps,
    departments,
    handleSubmit,
    handleModalClose
  };
};

const connectedDepartmentModal = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(DepartmentModal);

export { connectedDepartmentModal as DepartmentModal };
